import * as Dialog from '@radix-ui/react-dialog';
import type { HTMLAttributes, RefObject } from 'react';

import { ModalDialogBody } from '~/chords/ModalDialog/components/ModalDialogBody';
import { ModalDialogFooter } from '~/chords/ModalDialog/components/ModalDialogFooter';
import { ModalDialogHeader } from '~/chords/ModalDialog/components/ModalDialogHeader';
import {
  CONTENT_CLASS,
  OVERLAY_CLASS,
} from '~/chords/ModalDialog/components/styles';
import { renderSlot } from '~/chords/utils/renderSlot';
import { cn } from '~/lib/cn';

interface ModalDialogContentProps
  extends Dialog.DialogContentProps,
    HTMLAttributes<HTMLDivElement> {
  overlayRef?: RefObject<HTMLDivElement>;
  contentRef?: RefObject<HTMLDivElement>;
}

export function ModalDialogContent({
  overlayRef,
  contentRef,
  children,
  ...props
}: ModalDialogContentProps) {
  return (
    <Dialog.Portal>
      <Dialog.Overlay
        ref={overlayRef}
        className={cn(
          'pointer-events-none fixed inset-0 z-40 bg-overlay',
          OVERLAY_CLASS.show,
        )}
        role="none"
      />
      <Dialog.Content
        {...props}
        ref={contentRef}
        className={cn(
          'fixed z-50 flex flex-col overflow-hidden text-default',
          'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform',
          'max-h-[calc(100vh-20px)] min-w-[420px] max-w-[min(100vw,680px)]',
          'rounded-sm border-px bg-level-02 border-emphasis-subtle',
          'shadow-xl drop-shadow-xl',
          CONTENT_CLASS.show,
          props.className,
        )}
      >
        {renderSlot(ModalDialogHeader, children)}
        {renderSlot(ModalDialogBody, children)}
        {renderSlot(ModalDialogFooter, children)}
      </Dialog.Content>
    </Dialog.Portal>
  );
}

ModalDialogContent.displayName = 'ModalDialog.Content';
